module.exports = __webpack_public_path__ + "static/media/resume.27c261d7.pdf";